const applications = Object.freeze({
  RemPro: '964EB4C0-FB90-4F2E-A79F-B726D4E20077',
});

export default applications;
